/**基于d3的鼠标更新效果
 * @param { d3 selection } control - d3选择器
 * @param { d3 selection } el - d3选择器
 * @param { Function } render - 悬浮内容的render函数
 * @returns { String }
 */
let d3HoverTimer: any = null;
const onHidden = (control: any, el: any) => {
    // 样式调整
    control.attr("aria-show", false);
    el.style("opacity", 0).style("visibility", "hidden").attr("aria-show", false);
    d3HoverTimer && clearTimeout(d3HoverTimer);
    d3HoverTimer = setTimeout(() => {
        d3HoverTimer = null;
        el.on("mouseout", null);
        el.on("mouseover", null);
        control.on("mouseout", null);
        control.on("mousemove", null);
        el && el.style && el.style("display", "none");
    }, 200);
};

export const d3FollowHover = (control: any, el: any, render: any) => {
    // 鼠标移入注册
    control.on("mouseover", (e: any) => {
        // 调整详情框位置
        el.style("z-index", 6)
            .style("transition", `opacity 0.2s, visibility 0.2s, transform 0.4s`)
            .style("transform", `translate(${e.clientX + 20}, ${e.clientY})`)
            .style("position", "fixed")
            .style("display", "block")
            .style("left", 0)
            .html(render());

        // 清空已存在定时器
        d3HoverTimer && clearTimeout(d3HoverTimer);
        d3HoverTimer = setTimeout(() => {
            d3HoverTimer = null;
            control.attr("aria-show", true);
            el.style("opacity", 1).style("visibility", "initial").attr("aria-show", true);

            const info = el.node().getBoundingClientRect();
            if (info.x + info.width > document.body.clientWidth) {
                el.style("left", `-${info.width + 40}px`);
            }
        }, 200);

        // 鼠标移出注册
        control.on("mouseout", () => onHidden(control, el));

        // 鼠标移动事件
        control.on("mousemove", (e: any) => {
            el.style("transform", `translate(${e.clientX + 20}px, ${e.clientY}px)`);
        });

        // 悬浮窗鼠标移入事件
        el.on("mouseover", () => {
            // 样式调整
            control.attr("aria-show", true);
            el.style("opacity", 1).style("visibility", "initial").attr("aria-show", true);

            // 清除定时器
            d3HoverTimer && clearTimeout(d3HoverTimer);
        });

        // 悬浮窗鼠标移出事件
        el.on("mouseout", () => onHidden(control, el));
    });
};
